export class Device {
    dev_id:               number;
    dev_serial_no:        string;
    dev_label:           string;
    dev_status:           number;
    dev_type:             number;
    dev_operation_status: string;
    dev_di_count:         number;
    dev_do_count:         number;
    dev_ai_count:         number;
    dev_ao_count:         number;
    dev_evt_last_change:  number;
    dev_alarm_count:      number;
    is_deleted:           boolean;
    dev_version:          number;
    dev_comment:         string;
    dev_alarm_group_id:  number;
    deleted_on:          string;
    site_id:             number;
}